export enum LoanDashboardEventTarget {
  TabAllRequestsClick,
  TabApprovalPendingClick,
  TabAgreementRequestClick,
  TabFinalDisbursementClick,
  FilterClick,
  SearchClick,
  ExportToExcelClick,
  TabAllRepaymentClick,
  TabPendingRepaymentClick,
  ExportToExcelRepaymentClick,
}
